import { getDefaultExportFromCjs } from " commonjsHelpers.js";
import { __require as requireServer } from "/home/runner/work/strapi/strapi/packages/plugins/users-permissions/server/index.js";
var serverExports = requireServer();
export { serverExports as __moduleExports };
export default /*@__PURE__*/getDefaultExportFromCjs(serverExports);